import { call, put, takeEvery } from 'redux-saga/effects'
import {
    downloadQMSFeedbackDetail_API,
    getQMSFeedbackDetail_API,
} from '../../../../Config/Api';
import { createNotification } from '../../../../Config/NotificationToast';
import { instance } from "../../../auth/axiosInstance";
import { logOut } from '../../../../utils/Helper';

export default function* qmsFeedbackDetailsReportSaga() {
    yield takeEvery('GET_QMS_FEEDBACK_DETAILs_DATA', getQMSFeedbackDetails);
    yield takeEvery('DOWNLOAD_QMS_FEEDBACK_DETAILS_DATA', downloadQMSFeedbackDetails);
}


const getQMSFeedbackDetailsApi = async (data) => {
    try {
        const response = await instance.get(`${getQMSFeedbackDetail_API}?page=${data.pageNo|| 1}&limit=${data.pageSize || 10}&filter_from_date=${data.filter_from}&filter_to_date=${data.filter_to}${data.orderBy ? `&order_by=${data.orderBy}`: ''}${data.order ? `&order_by_type=${data.order?.toUpperCase()}`: ''}${data.searchText ? `filter_text=${data.searchText}`: ''}`, {
            data,
        });
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}
function* getQMSFeedbackDetails(action) {
    try {
        const response = yield call(getQMSFeedbackDetailsApi, action.data);
        if (response.statusCode === 200) {
            yield put({ type: 'GET_QMS_FEEDBACK_DETAILs_DATA_SUCCESS', payload: response.data });
        } else {
            if (response.statusCode === 401) {
                logOut('error', response.message);
            } else {
                createNotification('error', response.message);
                yield put({ type: 'GET_QMS_FEEDBACK_DETAILs_DATA_FAILURE', message: response.message });
            }
            
        }
        
    } catch (e) {
        console.log(e);
        yield put({ type: 'GET_QMS_FEEDBACK_DETAILs_DATA_FAILURE', message: e.message });
    }
}

const downloadQMSFeedbackDetailsApi = async(data)=> {
    try {
        const response = await instance.get(`${downloadQMSFeedbackDetail_API}?page=${data.pageNo|| 1}&limit=${data.pageSize || 10}&filter_from_date=${data.filter_from}&filter_to_date=${data.filter_to}${data.orderBy ? `&order_by=${data.orderBy}`: ''}${data.order ? `&order_by_type=${data.order?.toUpperCase()}`: ''}${data.searchText ? `filter_text=${data.searchText}`: ''}`, {
            responseType: 'arraybuffer',
        });
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        }
        return errors
    }
  }
  function* downloadQMSFeedbackDetails(action) {
    try {
        
        let data=action.data
        const response = yield call(downloadQMSFeedbackDetailsApi, data);
        if (response instanceof ArrayBuffer) {
            action.data?.onSuccessCallback(response)
            yield put({ type: 'DOWNLOAD_QMS_FEEDBACK_DETAILS_DATA_SUCCESS' });
        }if(response.response?.status===400){
            createNotification('error', 'No data found.');
        }else{
            createNotification('Unable to download sheet.')
        }
        yield put({ type: 'DOWNLOAD_QMS_FEEDBACK_DETAILS_DATA_FAILURE'});
        
    } catch (e) {
        console.log(e);
        yield put({ type: 'DOWNLOAD_QMS_FEEDBACK_DETAILS_DATA_FAILURE', message: e.message });
    }
}
